import { withTranslation } from 'react-i18next';
import Component from '../../components/Component';
import ListData from '../../components/ListData';

import { ConceptsSkeys, celebrityKeys } from './keys';
import query from './query';

class Summary extends Component {
    constructor(props) {
        super();
        this.query = query(props.page);
    }

    render() {
        const { t } = this.props;

        const dataForEntities = this.state.data?.filter((item) => item.wiki);
        const dataForConcepts = this.state.data?.filter((item) => !item.wiki);
        return (
            <div className="row">
                <div className="col-6 col-xs-12" id="top-celebrities">
                    <ListData
                        loading={this.state.loading}
                        header={this.props.header ?? t('discover.page.entities.header')}
                        subheader={this.props.subheader ?? t('discover.page.entities.subtitle')}
                        forceRun={this.forceRun}
                        link={`/domains/${this.props.domain_id}/categories`}
                        keys={celebrityKeys}
                        uniqKey="level"
                        data={dataForEntities}
                        itemClassName={this.props.page ? 'justify-content-start' : ''}
                        cardClassName={'list-data-full'}
                        customEmptyMessage={this.props.error_message}
                    />
                </div>
                <div className="col-6 col-xs-12" id="top-entities">
                    <ListData
                        loading={this.state.loading}
                        data={dataForConcepts}
                        label={this.props.label || t('discover.page.concepts.header')}
                        keys={ConceptsSkeys}
                        forceRun={this.forceRun}
                        header={this.props.header ?? t('discover.page.concepts.header')}
                        subheader={this.props.subheader ?? t('discover.page.concepts.subtitle')}
                        itemClassName={this.props.page ? 'justify-content-start' : ''}
                        cardClassName={'list-data-full'}
                        customEmptyMessage={this.props.error_message}
                    />
                </div>
            </div>
        );
    }
}

export default withTranslation()(Summary);
